(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("FEGORender"), require("FEGOEditor"), require("FEGOBridge"));
	else if(typeof define === 'function' && define.amd)
		define(["FEGORender", "FEGOEditor", "FEGOBridge"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/tile-swiper/render"] = factory(require("FEGORender"), require("FEGOEditor"), require("FEGOBridge"));
	else
		root["/fego/component/tile-swiper/render"] = factory(root["FEGORender"], root["FEGOEditor"], root["FEGOBridge"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__5322__, __WEBPACK_EXTERNAL_MODULE__4183__, __WEBPACK_EXTERNAL_MODULE__7145__) => {
return 